import React from "react";
import { Button, dialog, InputString } from "../../../../nq-component";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import { exportCSVUseCase } from "../../../../usecases/csv/usecases";
import { Progress, InfiniteScroll } from "../../../../nq-component";
import withRouter from "../../../../withRouter";
import Search from "../../../../components/Search";
import BaseListPage from "../../../../base/BaseListPage";
import NavBar from "../../../../components/navbar";
import InputFactory from "../../../../components/InputFactory";
import excludeFields from "../../ExcludeField";
import { footer, html, object, s } from "framer-motion/client";
import DialogCreate from "././components/DialogCreate";
import DialogDelete from "././components/DialogDelete";
import DialogReset from "././components/DialogReset";
import OnlineApplicantListPresenter from "./OnlineApplicantListPresenter";
import Table from "../../../../components/Table";
import OnlineDetails from "./components/OnlineDetails";

class OnlineApplicantListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new OnlineApplicantListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase()
    );
    this.state = {
      where: {},
      objects: [],
      selected: [],
      loading: false,
      total: 0,
      count: 0,
      showDetails: false,
      showFilters: false,
      empDetails: {},
      password: {},
    };
  }

  getCollectionName() {
    return "online_applicants";
  }

  componentWillUnmount() {
    if (this.presenter) {
      this.presenter.stopPolling();
    }
  }

  onChangeObject(value, field) {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [field]: value,
      },
    }));
  }

  handleSubmit = () => {
    this.presenter.handleSubmit(this.state.formData);
  };

  clickData(object, index) {
    this.setState({ showFilters: true, showDetails: true, empDetails: object });
  }

  hideFilter() {
    this.setState({ showDetails: false });
  }

  onClickView() {
    const { empDetails } = this.state;
    this.presenter.onClickView(empDetails);
  }

  handleDelete() {
    const { empDetails } = this.state;
    this.presenter.onClickDelete(empDetails);
  }

  onSubmitPassword() {
    this.presenter.onSubmitPassword(this.state.password);
  }
  onChange(value, field) {
    const schema = this.getSchema(this.getCollectionName());
    this.presenter.onChangePosition(value, schema);
  }

  onChangeReference(value, field) {
    const schema = this.getSchema(this.getCollectionName());
    this.presenter.onChangeReference(value, schema);
  }

  onClickAdd(object) {
    const schema = this.getSchemas();
    const formData = this.state.formData;

    dialog.fire({
      html: (
        <DialogCreate
          schema={schema}
          objects={object}
          onChangeData={this.onChangeObject.bind(this)}
          handleSubmit={this.handleSubmit.bind(this)}
        />
      ),
      footer: false,
    });
  }

  onClickDelete() {
    const { empDetails } = this.state;
    dialog.fire({
      html: (
        <>
          <DialogDelete
            empDetails={empDetails}
            clickDelete={this.handleDelete.bind(this)}
            clickClose={() => dialog.close()}
          />
        </>
      ),
      footer: false,
    });
  }

  onclickReset() {
    dialog.fire({
      html: (
        <>
          <DialogReset
            onChangeField={this.onChange.bind(this)}
            clickSubmit={this.onSubmitPassword.bind(this)}
            clickClose={() => dialog.close()}
          />
        </>
      ),
      footer: false,
    });
  }

  getAcl() {
    const user = this.getCurrentUser();
    return {
      read: ["*", user.id],
      write: ["*", user.id],
    };
  }

  // onChangeFilter(type, value, field) {
  //   const where = { ...this.state.where };
  //   switch (type) {
  //     case "Pointer":
  //       if (Object.keys(value).length > 0) {
  //         where[field] = { id: value.id };
  //       }
  //       break;
  //     case "Boolean":
  //       where[field] = value;
  //       break;
  //     default:
  //       where[field] = { $regex: value, $options: "i" };
  //       if (value) {
  //       }
  //   }
  //   // this.setState({ where });
  //   console.log(w)
  //   this.filterSubmit(where);
  // }

  showFilter() {
    this.setState({ showFilters: true });
  }

  hideFilter() {
    this.setState({ showFilters: false });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      objects,
      selected,
      count,
      progress,
      empDetails,
      formData,
      showFilters,
      showDetails,
    } = this.state;
    console.log("objects", objects);
    if (!schema) return <Progress />;
    const user = this.getCurrentUser();
    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1 className="fw-bold text-capitalize">
                  {schema.label || this.getCollectionName()}
                </h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{count}</span>
                </div>
              </div>
              <div className="d-flex justify-content-start">
                <p
                  className="align-self-end m-0 cursor-pointer fw-bold"
                  style={{ color: `#D18237` }}
                  onClick={this.showFilter.bind(this)}
                >
                  <i class="bi bi-filter"></i>Filters
                </p>
              </div>
              <div className="d-flex">
                {showFilters ? (
                  <div
                    className="d-flex flex-column me-2"
                    style={{
                      flex: "0 0 30%",
                      minWidth: "250px",
                      position: "sticky",
                      top: 0,
                      alignSelf: "flex-start",
                      zIndex: 1,
                    }}
                  >
                    <div className="card p-3 mt-1">
                      <h6 className="fw-bold" style={{ color: "black" }}>
                        <i
                          class="bi bi-arrow-left me-2"
                          onClick={this.hideFilter.bind(this)}
                        ></i>
                        Filters
                      </h6>
                      {/* <label className="">Applicants</label>
                      <Search
                        schemas={this.getSchemas()}
                        className="mt-1"
                        onSubmit={this.searchSubmit.bind(this)}
                        fields={searchApplicants}
                      /> */}

                      <div className="d-flex flex-column">
                        {Object.keys(schema.filters || {}).map((field) => {
                          let { type, label, ...options } =
                            schema.filters[field];
                          return (
                            <>
                              <label>{label}</label>
                              <InputFactory
                                key={field}
                                className="ms-1"
                                type={type}
                                field={field}
                                where={{}}
                                onChange={this.onChangeFilter.bind(this, type)}
                                {...options}
                              />
                            </>
                          );
                        })}
                      </div>
                    </div>
                    {showDetails && empDetails && (
                      <OnlineDetails
                        onlineDetails={empDetails}
                        clickReset={this.onclickReset.bind(this)}
                        clickView={this.onClickView.bind(this)}
                        clickDelete={this.onClickDelete.bind(this)}
                      />
                    )}
                  </div>
                ) : (
                  ""
                )}

                <div
                  className="flex-grow-1"
                  style={{
                    overflowX: "auto",
                  }}
                >
                  <Table
                    fields={schema.fields}
                    onClick={this.clickData.bind(this)}
                    objects={objects}
                    // selectable
                    // collapsable
                    excludeFields={Object.keys(schema.fields).reduce(
                      (acc, key) => {
                        const options = schema.fields[key];
                        if (excludeFields.includes(key)) {
                          acc.push(key);
                        }
                        if (options.read === false) {
                          acc.push(key);
                        }
                        switch (options._type || options.type) {
                          case "Relation":
                          case "Array":
                          case "Object":
                          case "File":
                            acc.push(key);
                            break;
                          default:
                        }
                        return acc;
                      },
                      excludeFields
                    )}
                    selected={selected}
                    onSelect={this.onSelect.bind(this)}
                    onSelectAll={this.onSelectAll.bind(this)}
                    onSort={this.onClickSort.bind(this)}
                    progress={progress}
                    onClickItem={this.onClickItem.bind(this)}
                    className="mt-1"
                  />
                </div>
              </div>
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(OnlineApplicantListPage);
